import { ReactElement, memo } from 'react';
import { Stack, Typography } from '@mui/material';
import QRCodeComponent from 'react-qr-code';

import { OrderMFlexQRCommonProps } from '../types';

import { OrderMFlexQRInfoChip, OrderMFlexQRInfoCopyButton } from './styles';

const OrderMFlexQRInfo = ({
  qrData,
  referenceId,
}: OrderMFlexQRCommonProps): ReactElement => (
  <Stack spacing={2} alignItems="center">
    <QRCodeComponent value={qrData} size={180} level="L" />

    {referenceId && (
      <OrderMFlexQRInfoChip>
        <Typography variant="caption" color="common.white" fontWeight="bold">
          {referenceId}
        </Typography>

        <OrderMFlexQRInfoCopyButton text={referenceId} size="small" />
      </OrderMFlexQRInfoChip>
    )}
  </Stack>
);

export default memo(OrderMFlexQRInfo);
